import React from 'react';
import { Controller } from 'react-hook-form';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Chip,
    Box,
    OutlinedInput,
    makeStyles,
} from '@material-ui/core';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const symptoms = [
    'Problemas de memória e concentração',
    'Mudanças no humor',
    'Sensibilidade exagerada na pele',
    'Dor de cabeça',
    'Ansiedade',
    'Náusea/Vômitos',
    'Cansaço',
    'Depressão',
    'Desejo por comidas específicas',
    'Aura (sintomas visuais ou sensoriais antes da dor de cabeça)',
    'Escotomas cintilantes (pontos brilhantes na visão)',
    'Distorção visual',
    'Coceira ou sensação de agulhamento',
    'Sensibilidade à luz (fotofobia)',
    'Sensibilidade ao som',
    'Sensibilidade ao som (fonofobia)',
    'Congestão nasal',
];

const useStyles = makeStyles((theme) => ({
    textField: {
        marginTop: theme.spacing(2),
    },
    chipsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(0.5),
        overflow: 'hidden',
    },
    formControl: {
        width: '100%',
    },
    select: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.875rem',
        },
    },
    menuItem: {
        [theme.breakpoints.down('xs')]: {
            fontSize: '0.875rem',
        },
    },
}));

const MultipleSelectChip = ({ control, errors }: any) => {
    const classes = useStyles();
    return (
        <Controller
            name="initialDiseaseSymptoms"
            control={control}
            rules={{ required: 'Sintomas iniciais são obrigatórios' }}
            render={({ field }) => (
                <FormControl fullWidth variant="outlined" error={!!errors.initialDiseaseSymptoms} className={classes.formControl}>
                    <InputLabel id="initial-disease-symptoms-label">Quais foram os sintomas iniciais da enxaqueca?</InputLabel>
                    <Select
                        {...field}
                        labelId="initial-disease-symptoms-label"
                        multiple
                        value={field.value ? field.value.split(', ') : []}
                        input={<OutlinedInput label="Quais foram os sintomas iniciais da enxaqueca?" />}
                        renderValue={(selected) => (
                            <Box className={classes.chipsContainer}>
                                {(selected as string[]).map((value) => (
                                    <Chip key={value} label={value} />
                                ))}
                            </Box>
                        )}
                        MenuProps={MenuProps}
                        onChange={(event) => {
                            const value = event.target.value as string[];
                            field.onChange(value.join(', '));
                        }}
                        className={classes.select}
                    >
                        {symptoms.map((symptom) => (
                            <MenuItem key={symptom} value={symptom} className={classes.menuItem}>
                                {symptom}
                            </MenuItem>
                        ))}
                    </Select>
                    {errors.initialDiseaseSymptoms && <p>{errors.initialDiseaseSymptoms.message}</p>}
                </FormControl>
            )}
        />
    );
};

export default MultipleSelectChip;